// The TikTok family — one connectable provider.
//
// `tiktok_pixel` and `tiktok_catalog` are registered from inside `TiktokIntegration.vue` and have
// no `INTEGRATIONS_CONFIGS` entry; they are modelled in `channels.ts` as sub-entities of this
// provider. Their v3 standalone SFCs (`TiktokPixelIntegration`, `TiktokCatalogIntegration`) had no
// importer and have since been deleted from v3 outright, so there is nothing to port for them
// beyond the display rows.

import type { IntegrationProvider } from '../providers.types'

export const TIKTOK_PROVIDERS: readonly IntegrationProvider[] = [
  {
    key: 'tiktok_ads_account',
    id: 'tiktok_ads_account',
    nameKey: 'integrations.providers.tiktokAds',
    category: 'paid_advertising',
    authFamily: 'tiktok_oauth',
    connect: 'oauth',
    configComponent: () => import('../../components/connectors/TiktokConnector.vue'),
    labelFields: ['advertiser_name', 'tiktok_account_advertiser_id'],
    allowsMultiple: true,
    logo: 'tiktok_ads',
  },
]
